import script from "./CategorySwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySwitcher.vue?vue&type=script&setup=true&lang=js"

import "./CategorySwitcher.vue?vue&type=style&index=0&id=567fef4a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567fef4a"]])

export default __exports__